import React, { forwardRef } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useDittoForm } from '@ow/ditto-core'
import FieldErrorFallback from './FieldErrorFallback'
import { ditto } from '../../ditto/register.field'
import Field from './field'

const ErrorTip = ({ opts, error }) => {
  return <FieldErrorFallback opts={opts} error={error} />
}
const WebBasic = (
  { fields = [], data = {}, waterMarkDefs, widgets, className },
  ref
) => {
  const { control, formControl, unregister, formState, editableFields } =
    useDittoForm(
      {
        fields,
        allFields: fields,
        data,
        ditto,
      },
      ref
    )
  console.log(editableFields, 'fieldsfields')

  return (
    <div className={`${className} h-full `}>
      <form className="h-full">
        {editableFields.map((opts) => {
          return (
            <ErrorBoundary
              FallbackComponent={<ErrorTip opts={opts} />}
              key={opts.slug}
            >
              <Field
                fields={editableFields}
                opts={opts}
                widgets={widgets}
                error={formState.errors[opts.slug]}
                errors={formState.errors}
                control={control}
                unregister={unregister}
                data={data}
                formControl={formControl}
                waterMarkDefs={waterMarkDefs}
              />
            </ErrorBoundary>
          )
        })}
      </form>
    </div>
  )
}

export default forwardRef(WebBasic)
